
function parseDateTime(dateTimeString) {
  var parts = dateTimeString.split(' ');
  var dateParts = parts[0].split('-');
  var timeParts = parts[1].split(':');
  return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
}

function startCountdown(endDate) {
  const daysElement = document.getElementById('days');
  const hoursElement = document.getElementById('hours');
  const minutesElement = document.getElementById('minutes');
  const secondsElement = document.getElementById('seconds');

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance < 0) {
      clearInterval(interval);
      daysElement.innerHTML = '00';
      hoursElement.innerHTML = '00';
      minutesElement.innerHTML = '00';
      secondsElement.innerHTML = '00';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysElement.innerHTML = String(days).padStart(2, '0');
    hoursElement.innerHTML = String(hours).padStart(2, '0');
    minutesElement.innerHTML = String(minutes).padStart(2, '0');
    secondsElement.innerHTML = String(seconds).padStart(2, '0');
  }

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown();
}

// 设置倒计时结束日期
// const countdownDate = new Date("2024-06-24T14:00:00Z").getTime();
// const countdownDate = new Date("7/15/2024 14:00:00").getTime();
var countdownElement = document.getElementById('gift_counter_down');
var endTime = countdownElement.getAttribute('data-end-time');
const countdownDate = parseDateTime(endTime).getTime();
startCountdown(countdownDate);
